
import { defineComponent } from 'vue';

export default defineComponent({ data: () => ({ burger: false }) });
